module.exports = __webpack_public_path__ + "static/media/tablet-ipad.d8601726.svg";